import React, { useEffect, useState, useRef } from 'react';
import styles from '../styles/Application.module.css';
//import Header from './ApplicationContent/HeaderApplication'
import Users from './ApplicationContent/Users'
import Desktop from './ApplicationContent/Desktop'

import * as firebase from 'firebase/app';
import { getCurrentUser } from '../firebaseConfig';
import { Link } from 'react-router-dom'
import { logoutUser } from '../firebaseConfig';
import { useHistory } from 'react-router-dom';

const Application = (props) => {
  
  const [allUsers, setAllUsers] = useState();
  const [user, setUser] = useState();
  //const [selectedUser, setSelectedUser] = useState(); // getting ...
  const [checkLoggedUser, setCheckLoggedUser] = useState(false);

  const [desktopOn, setDesktopOn] = useState(false);
  const [UuID, setUuID] = useState();
  const [indexUID, setIndexUID] = useState();
  const [name, setName] = useState('');

  const history = useHistory();

  const logOut = () => {
    logoutUser();
    console.log("Odjavili ste se!")
    history.push('/Login');
  }

  // *
  // best way to check for mounted component !!
  const isCurrent = useRef(true);

  useEffect(() => {
    return () => {
      isCurrent.current = false;
    }
  }, [])
  // * for checking mounted components
  // *
  // then use 
  // if (isCurrent.current) { setState(XXYY) }  !!

  const getDataFirebase = () => {
    //let array: any;
    let data;
    console.log("checking how many times it renders !!")
    // getting data from location for WEIGHT
    let getData = firebase.database().ref('/users/');
    getData.on('value', function(snapshot) {
      console.log(snapshot.val());
      data = snapshot.val();
      if (data !== null) {
        // getting data to correct form ID: [key], NAME:
        const allUsersData = Object.keys(data).map( key => {
          return  { id: key, name: data[key].username, share: data[key].share };
        })
        
        if (isCurrent.current) { setAllUsers(allUsersData) } 
      }
    })
  }

  const checkUser = () => {
    getCurrentUser().then((user) => {
      if(user) {
          console.log(user);
          setUser(user.email.split('@')[0])
          //setCheckLoggedUser(true);
          if (isCurrent.current) { setCheckLoggedUser(true) }
      } else {
          console.log("not connected")
          history.push('/Login')
          console.log('no user back to -> /Login');
          //setCheckLoggedUser(false);
          if (isCurrent.current) { setCheckLoggedUser(false) }
      }
    })
  }

  // DESKTOP section after u click on USER
  let desktop = null;

  const userClickHandler = (userUID, index, name) => {      
    setUuID(userUID)
    setIndexUID(index)
    setDesktopOn(true)
    setName(name)
  }
  if (desktopOn) {
    desktop = (
      <Desktop data={UuID} idata={indexUID} name={name} />
    )
  }
/*---------------------------------------------*/
  useEffect(() => {
    console.log("checkuser")
    checkUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
//----------------------------------------/
// RUNING USEEFFECT ONLY ONCE !!!!! on update !!!
const isInitialMount = useRef(true);

useEffect(() => {
  if (isInitialMount.current) {
      isInitialMount.current = false;
  } else {
      // Your useEffect code here to be run on update
      console.log("Getting data-Users from firebase!")
      getDataFirebase();
  }
}, [checkLoggedUser]);

const isInitialMountAllUsers = useRef(true);
useEffect(() => {
  if (isInitialMountAllUsers.current) {
      isInitialMountAllUsers.current = false;
  } else {
      // Your useEffect code here to be run on update
      console.log('rendering allUsers: ', allUsers)
  }
}, [allUsers]);

//--------------------------------------------------//
  // useEffect(() => {
  //   console.log("Getting data-Users from firebase!")
  //   getDataFirebase();
  // }, [])
  

  // useEffect(() => {
  //   console.log('rendering allUsers: ', allUsers)
  // }, [allUsers]);

  //---------------------- TEST -------
  // useEffect(() => {
  //   console.log("selectedUser: " + selectedUser)
  // }, [selectedUser])
  

  return (
    <div className={styles.App}>
      <div className={styles.InApp}>
        <div className={styles.InAppLeft}>
          <p>Hello {user}</p>
          <Users 
            data={allUsers} 
            userClick={(userUID, index, name) => userClickHandler(userUID, index, name)} />
          <div className={styles.LeftAppMenu}>
            <div className={styles.Nav}>
              <div className={styles.Ul}>
                <div className={styles.Li}>
                  <img className={styles.HomeIcon} src={require('../icons/calendar.png')} alt="Home icon" />
                  <Link to="/Koledar" >Koledar</Link>
                </div>
                <div className={styles.Li}>
                  <img className={styles.HomeIcon} src={require('../icons/home.png')} alt="Home icon" />
                  <Link to="/" >Home</Link>
                </div>
                <div className={styles.Li}>
                  <img className={styles.SignOutIcon} src={require('../icons/signout.png')} alt="Sign-out icon" />
                  <div 
                    className={styles.LiButton}
                    onClick={() => logOut()} >Odjavi se</div>
                </div>
              </div>
            </div>
          </div>    
        </div>
        
        <div className={styles.InAppRight}>
          { 
            /*<Header />*/ 
          }
          {desktop}
        </div>
      </div>
    </div>
  );
}
  
export default Application;